import { render, staticRenderFns } from "./BCXMultiselectFilter.vue?vue&type=template&id=66601cda&scoped=true"
import script from "./BCXMultiselectFilter.vue?vue&type=script&lang=ts"
export * from "./BCXMultiselectFilter.vue?vue&type=script&lang=ts"
import style0 from "./BCXMultiselectFilter.vue?vue&type=style&index=0&id=66601cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66601cda",
  null
  
)

export default component.exports